import { AssignmentType } from '@/types/schema';

import { AssignmentCreatorInitialContentType } from '../../type';
import { AssignmentFormValues } from './config';

export interface EditorProps {
  onSubmit: (values: AssignmentFormValues) => void;
  setSubmitRef: (formikSubmit: Function) => void;
  assignment?: AssignmentType;
  isDuplicating?: boolean;
  initialContents?: AssignmentCreatorInitialContentType;
}

export enum AssignmentCreatorSectionKeys {
  Content = 'CONTENT',
  Learners = 'LEARNERS',
  LearnerGroups = 'LEARNER_GROUPS',
  Settings = 'SETTINGS',
  Details = 'DETAILS',
}
